"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TOGGLE_DIALOG_STATE = exports.TIMER_TICK = exports.TIMER_START = exports.TIMER_CLEAR = exports.StatusTextState = exports.STOP_BUTTON = exports.STATUS_TEXT_STATE = exports.STATUS_TEXT_SET = exports.STATUS_TEXT_GL = exports.STATUS_TEXT_CLEAR = exports.SPIN_BUTTON = exports.SPACE_BUTTON = exports.SHOW_SPIN_BUTTON = exports.SHOW_ALL_PAY_LINES = exports.SET_PROMO_GAME_TEXT = exports.SET_IDLE_TEXT = exports.SET_DIALOG_CUSTOM_TEXT = exports.SET_DIALOG_CUSTOM_ACTIONS = exports.SET_DIALOG_ACTIONS = exports.RESET_DIALOG_ACTIONS = exports.REQUEST_DIALOG_STATE_ACTIONS = exports.REQUEST_DIALOG_STATE = exports.REQUEST_CUSTOM_DIALOG = exports.PromptState = exports.PROMPT_SET_STATE = exports.PENDING_SERVER_RESPONSE = exports.ORIENTATION_BLOCK = exports.MULTI_SPIN_BUTTON = exports.HIDE_SPIN_BUTTON = exports.ESC_BUTTON = exports.DIALOG_STATE = exports.DIALOG_OK = exports.DIALOG_NO = exports.DIALOG_EXIT = exports.DIALOG_CLOSE = exports.DIALOG_CANCEL = exports.BLITZ_TOGGLE_BUTTON = exports.BLITZ_BUTTON = exports.AUTO_PLAY_BUTTON = void 0;
var PromptState = exports.PromptState = /*#__PURE__*/function (PromptState) {
  PromptState[PromptState["Hide"] = 0] = "Hide";
  PromptState[PromptState["Error"] = 1] = "Error";
  PromptState[PromptState["InvalidToken"] = 2] = "InvalidToken";
  PromptState[PromptState["PlayerLocked"] = 3] = "PlayerLocked";
  PromptState[PromptState["APIDown"] = 4] = "APIDown";
  PromptState[PromptState["ContactSupport"] = 5] = "ContactSupport";
  PromptState[PromptState["InvalidPlayerId"] = 6] = "InvalidPlayerId";
  PromptState[PromptState["Timeout"] = 7] = "Timeout";
  PromptState[PromptState["FailedToConnect"] = 8] = "FailedToConnect";
  PromptState[PromptState["Reconnecting"] = 9] = "Reconnecting";
  PromptState[PromptState["Disconnected"] = 10] = "Disconnected";
  PromptState[PromptState["Maintenance"] = 11] = "Maintenance";
  PromptState[PromptState["GameInEarlyAccess"] = 12] = "GameInEarlyAccess";
  PromptState[PromptState["CountryBlocked"] = 13] = "CountryBlocked";
  PromptState[PromptState["ReplayRoundIdNotFound"] = 14] = "ReplayRoundIdNotFound";
  return PromptState;
}({}); //Actions
/**
 * Idle text. only in play when round is no idle/ended.
 * Does not show during features
 */
var SET_IDLE_TEXT = exports.SET_IDLE_TEXT = "SET_IDLE_TEXT";
/**
 * Hard set of status text. will translate payload key.
 */
var STATUS_TEXT_STATE = exports.STATUS_TEXT_STATE = "STATUS_TEXT_STATE";
/**
 * Used for shared status texts.
 */
var STATUS_TEXT_SET = exports.STATUS_TEXT_SET = "STATUS_TEXT_SET";

/**
 * Clear current status text
 */
var STATUS_TEXT_CLEAR = exports.STATUS_TEXT_CLEAR = "STATUS_TEXT_CLEAR";
var STATUS_TEXT_GL = exports.STATUS_TEXT_GL = "STATUS_TEXT_GL";
var TIMER_START = exports.TIMER_START = "TIMER_START";
var TIMER_CLEAR = exports.TIMER_CLEAR = "TIMER_CLEAR";
var TIMER_TICK = exports.TIMER_TICK = "TIMER_TICK";
var ORIENTATION_BLOCK = exports.ORIENTATION_BLOCK = "ORIENTATION_BLOCK";
var PROMPT_SET_STATE = exports.PROMPT_SET_STATE = "PROMPT_SET_STATE";
var REQUEST_DIALOG_STATE = exports.REQUEST_DIALOG_STATE = "REQUEST_DIALOG_STATE";
/**   dialog state with actions after ok */
var REQUEST_DIALOG_STATE_ACTIONS = exports.REQUEST_DIALOG_STATE_ACTIONS = "REQUEST_DIALOG_STATE_ACTIONS";
var TOGGLE_DIALOG_STATE = exports.TOGGLE_DIALOG_STATE = "TOGGLE_DIALOG_STATE";
var SET_DIALOG_ACTIONS = exports.SET_DIALOG_ACTIONS = "SET_DIALOG_ACTIONS";
var RESET_DIALOG_ACTIONS = exports.RESET_DIALOG_ACTIONS = "RESET_DIALOG_ACTIONS";
var REQUEST_CUSTOM_DIALOG = exports.REQUEST_CUSTOM_DIALOG = "REQUEST_CUSTOM_DIALOG";
var SET_DIALOG_CUSTOM_TEXT = exports.SET_DIALOG_CUSTOM_TEXT = "SET_DIALOG_CUSTOM_TEXT";
var SET_DIALOG_CUSTOM_ACTIONS = exports.SET_DIALOG_CUSTOM_ACTIONS = "SET_DIALOG_CUSTOM_ACTIONS";
var DIALOG_STATE = exports.DIALOG_STATE = "DIALOG_STATE";
var DIALOG_CANCEL = exports.DIALOG_CANCEL = "DIALOG_CANCEL";
var DIALOG_EXIT = exports.DIALOG_EXIT = "DIALOG_EXIT";
var DIALOG_OK = exports.DIALOG_OK = "DIALOG_OK";
var DIALOG_NO = exports.DIALOG_NO = "DIALOG_NO";
var DIALOG_CLOSE = exports.DIALOG_CLOSE = "DIALOG_CLOSE";

/**
 * Button to START auto play. bring up the dialog.
 * if pressed during manual free spins it will start auto play free spins.
 * Only relevant for games with manual free spins.
 */
var AUTO_PLAY_BUTTON = exports.AUTO_PLAY_BUTTON = "AUTO_PLAY_BUTTON";
var MULTI_SPIN_BUTTON = exports.MULTI_SPIN_BUTTON = "MULTI_SPIN_BUTTON";
var SPIN_BUTTON = exports.SPIN_BUTTON = "SPIN_BUTTON";
var STOP_BUTTON = exports.STOP_BUTTON = "STOP_BUTTON";
var SPACE_BUTTON = exports.SPACE_BUTTON = "SPACE_BUTTON";
var ESC_BUTTON = exports.ESC_BUTTON = "ESC_BUTTON";
var BLITZ_TOGGLE_BUTTON = exports.BLITZ_TOGGLE_BUTTON = "BLITZ_TOGGLE_BUTTON";
var BLITZ_BUTTON = exports.BLITZ_BUTTON = "BLITZ_BUTTON";
var SHOW_ALL_PAY_LINES = exports.SHOW_ALL_PAY_LINES = "SHOW_ALL_PAY_LINES";
var HIDE_SPIN_BUTTON = exports.HIDE_SPIN_BUTTON = "HIDE_SPIN_BUTTON";
var SHOW_SPIN_BUTTON = exports.SHOW_SPIN_BUTTON = "SHOW_SPIN_BUTTON";
var SET_PROMO_GAME_TEXT = exports.SET_PROMO_GAME_TEXT = "SET_PROMO_GAME_TEXT";

/**When UI needs Server to response before allowing player to continue, such as promotion start. */
var PENDING_SERVER_RESPONSE = exports.PENDING_SERVER_RESPONSE = "PENDING_SERVER_RESPONSE";
var StatusTextState = exports.StatusTextState = /*#__PURE__*/function (StatusTextState) {
  StatusTextState[StatusTextState["Idle"] = 0] = "Idle";
  StatusTextState[StatusTextState["Running"] = 1] = "Running";
  StatusTextState[StatusTextState["TotalWin"] = 2] = "TotalWin";
  StatusTextState[StatusTextState["WonOnLine"] = 3] = "WonOnLine";
  StatusTextState[StatusTextState["Win"] = 4] = "Win";
  StatusTextState[StatusTextState["RoundEndNoWin"] = 5] = "RoundEndNoWin";
  StatusTextState[StatusTextState["Blitz"] = 6] = "Blitz";
  StatusTextState[StatusTextState["BlitzStop"] = 7] = "BlitzStop";
  StatusTextState[StatusTextState["Nothing"] = 8] = "Nothing";
  return StatusTextState;
}({});
//# sourceMappingURL=types.js.map